import React from "react";
import "../styles/About.scss";
import { Link } from "react-router-dom";
import VideoPlayer from "./VideoPlayer";
import "video.js/dist/video-js.css";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: [
        {
          autoplay: false,
          controls: true,
          poster: "http://estelleleeds.com/videos/reel2021_2.jpg",
          sources: [
            {
              src: "http://estelleleeds.com/videos/reel2021.mp4",
              type: "video/mp4",
            },
          ],
        },
      ],
    };
  }
  render() {
    return (
      <div className="container about">
        <p>&nbsp;</p>
        <h2 className="serif-italic-font">Estelle Leeds Artists Management</h2>

        <div className="data-vjs-player">
          <VideoPlayer {...this.state.videos[0]} />
        </div>
        <br />
        {/*
        <Link
          to={`${process.env.PUBLIC_URL}/artists/directors`}
          className="btn-enter"
        >
          Enter Site{" "}
        </Link>
    */}
        <p>
          Neuehouse
          <br />
          Gallery Suite
          <br />
          110 East 25th Street
          <br />
          New York NYC 10010
        </p>
        <br />
        <p>
          <span>Phone: </span>
          917 553 0646
        </p>
        <br />
        <p>
          <span>E-Mail: </span>
          <a
            href="mailto:estelle@estelleleeds.com"
            title="Opens window for sending email"
          >
            estelle@estelleleeds.com
          </a>
        </p>
        <br />
        <p className="serif-italic-font">Estelle Leeds PR by PMK LA</p>
        <br />
      </div>
    );
  }
}

export default About;
